// Los artículos del centro de ayuda, servidos por /api/ayuda.
//
// El frontend no lee los .md: corre en un navegador. El servidor se los sirve ya
// filtrados por los módulos de la cuenta — leer sobre algo que no existe acá es
// ruido, y en una cuenta cliente le muestra funciones que no compró.

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export interface ArticuloEnLista {
  id: string;
  titulo: string;
  resumen: string;
  modulo: string;
  ruta: string | null;
}

export interface ArticuloCompleto extends ArticuloEnLista {
  cuerpo: string;
}

/** El listado. Solo se pide cuando el panel está abierto: nadie necesita la
 *  ayuda cargada de fondo toda la sesión. */
export function useArticulosDeAyuda(habilitado: boolean) {
  return useQuery<{ articulos: ArticuloEnLista[] }>({
    queryKey: ['ayuda', 'articulos'],
    queryFn: () => api.get<{ articulos: ArticuloEnLista[] }>('/api/ayuda/articulos'),
    enabled: habilitado,
    // El contenido cambia con un despliegue, no durante la sesión.
    staleTime: 30 * 60_000,
  });
}

export function useArticuloDeAyuda(id: string | null) {
  return useQuery<ArticuloCompleto>({
    queryKey: ['ayuda', 'articulo', id],
    queryFn: async () => {
      const r = await api.get<{ articulo: ArticuloCompleto }>(`/api/ayuda/articulos/${String(id)}`);
      return r.articulo;
    },
    enabled: id !== null,
    staleTime: 30 * 60_000,
  });
}
